<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <!--<div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3">
                        <small>Sign up with</small>
                    </div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div>-->
                <div class="card-body px-lg-5 py-lg-5">
                    <!--<div class="text-center text-muted mb-4">
                        <small>Or sign up with credentials</small>
                    </div>-->
                    <form role="form">

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Name"
                                    addon-left-icon="ni ni-hat-3"
                                    v-model="name">
                        </base-input>

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="email">
                        </base-input>

                        <base-input class="input-group-alternative"
                                    placeholder="Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="password">
                        </base-input>

                        <div class="text-muted font-italic">
                           <password v-model="password" :strength-meter-only="true" @score="updatePasswordScore" />
                        </div>

                        <div class="row my-4">
                            <div class="col-12">
                                <base-checkbox class="custom-control-alternative" v-model="privacy">
                                    <span class="text-muted">I agree with the <a href="https://frozencrow.com/" target="_blank">Privacy Policy</a></span>
                                </base-checkbox>
                            </div>
                        </div>
                        <div class="text-center">
                            <base-button type="primary" class="my-4" @click.prevent="register(email, password, name, privacy)" :disabled="privacy === false">Create account</base-button>
                        </div>
                    </form>
                    <div class="alert alert-danger" role="alert" v-if="registerError">
                      <strong>Whoops!</strong> {{ registerError }}
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-right">
                    <router-link to="/login" class="text-light">
                        <small>Login into your account</small>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Password from 'vue-password-strength-meter';
export default {
	name: 'register',
	components: { Password },
	data() {
		return {
			name: '',
			email: '',
			password: '',
			privacy: false,
			registerError: false,
			passwordScore: 0
		}
	},
	methods: {
		updatePasswordScore (score) {
			this.passwordScore = score;
		},
		register (email, password, name, privacy) {
			if (!privacy) {
				this.registerError = 'Please agree to our Privacy Policy!';
				return;
			}
			if (this.passwordScore < 2) {
				this.registerError = 'Password too weak! Please try adding at least 1 number and special character';
				return;
			}
			this.registerError = false;
			const {
				User
			} = this.$FeathersVuex.api
			new User({
				email,
				password,
				name,
			})
			.save()
			.then(() => {
				this.$store.dispatch('auth/authenticate', {
						strategy: 'local',
						email,
						password
					})
					.then(() => {
						this.$router.push('/');
					});
			})
			// Just use the returned error instead of mapping it from the store.
			.catch(err => {
				// Convert the error to a plain object and add a message.
				if (err.data ) {
					let type = err.data.code;
					err = Object.assign({}, err);
					err.message =
						type === 11000 ?
						'That email address is unavailable.' :
						'An error prevented signup.'
				}
				this.registerError = err.message;
			});
		}
	}
}
</script>
<style>
</style>
